import { MonitoringType } from 'shared/components/monitoring/monitoring-type';

export enum FaultType {
  Offline = 'Offline',
  BatteryCritical = 'BatteryCritical',
  BatteryLow = 'BatteryLow',
  OutDated = 'OutDated',
  GatewayDown = 'GatewayDown',
  DeviceMalfunction = 'DeviceMalfunction',
}

export const toMonitoringType = (fault: FaultType | undefined): MonitoringType | undefined => {
  switch (fault) {
    case FaultType.Offline:
      return MonitoringType.Offline;
    case FaultType.BatteryCritical:
      return MonitoringType.BatteryCritical;
    case FaultType.BatteryLow:
      return MonitoringType.BatteryLow;
    case FaultType.OutDated:
      return MonitoringType.OutDated;
    case FaultType.GatewayDown:
      return MonitoringType.GatewayOffline;
    case FaultType.DeviceMalfunction:
      return MonitoringType.DeviceMalfunction;
    default:
      return undefined;
  }
};
